export default {
  // ========== Encabezado ==========
  pa: "PA",
  suitcase: "Maleta",
  didactic: "Didáctica",
  subjectProgram: "Programa de Asignatura",

  // ========== Sección 1: Antecedentes Generales ==========
  generalBackground: "Antecedentes Generales",
  totalHours: "Horas Totales",
  inPersonDirectTeaching: "Docencia Dirigida Presencial",
  pedagogicalHours: "Horas Pedagógicas",
  nonInPersonDirectTeaching: "Docencia Dirigida No Presencial",
  prerequisites: "Prerrequisitos",
  autonomousWorkChronologicalHours: "Horas Cronológicas de Trabajo Autónomo",
  noPrerequisites: "Sin Prerrequisitos",

  // ========== Sección 2: Descripción de la Asignatura ==========
  subjectDescription: "Descripción de la Asignatura",
  noEntityForSubject: "No hay {entity1} para {entity2}.",
  learningResult: "Resultado de Aprendizaje",
  achievementIndicator: "Indicador de Logro",
  noSubjectDescription: "No hay Descripción de la Asignatura",

  // ========== Sección 3: Síntesis de la Ruta de Aprendizaje ==========
  learningRouteSynthesis: "Síntesis de la Ruta de Aprendizaje",
  learningExperience: "Experiencia de Aprendizaje",
  activitiesAndEvaluations: "Actividades y Evaluaciones",
  learningEnvironments: "Ambientes de Aprendizaje",
  hoursCount: "N° Horas",
  activityAssociatedToVcm: "Actividad Asociada a VCM",
  total: "Total",
  noLearningRouteSynthesis: "No hay {entity}.",

  // ========== Sección 4: Evaluaciones ==========
  evaluations: "Evaluaciones",
  evaluation: "Evaluación",
  evaluativeSituation: "Situación Evaluativa",
  partialEvaluationWeighting: "Ponderación de la Evaluación Parcial (%)",
  finalWeighting: "Ponderación Final",
  noPartialEvaluations: "No hay Evaluaciones Parciales.",

  // ========== Sección 5: Bibliografía Obligatoria ==========
  mandatoryBibliography: "Bibliografía Obligatoria",
  noMandatoryBibliography: "No hay Bibliografía Obligatoria.",
}
